// extracted by mini-css-extract-plugin
export default {"link":"skip-link-module--link--b099d"};